import styled from 'styled-components/macro';
import {useLoggedIn} from "../store";
import Overlay from "./overlay";
import NavLink from "./nav_link";
import isStandardBaseCommunity from "../utils/base_community";
import {useBaseCommunity} from "../store/hooks";
import {themecolors} from "../utils/themecolors";
import {
    ArrowUpWideNarrow,
    Calendar,
    CalendarCheck,
    Clock,
    Infinity,
    MessageCircle,
    Rocket,
    TrendingUp,
    Zap
} from "lucide-react";

const Menu = styled.div``;
const Item = styled.div``;
const Heading = styled.div``;

const listingPath = (community, sort, customFeed, loggedIn) => {
    if (customFeed) return `/feed/${customFeed.id}/${customFeed.slug}/${sort}`;
    const isStandardBase = isStandardBaseCommunity();
    const baseCommunity = useBaseCommunity().toLowerCase();
    if (!isStandardBase) return community.toLowerCase() === baseCommunity ? `/${sort}` : `/c/${community}/${sort}`;
    return community && (loggedIn ? community !== 'home' : (community !== 'all' && community !== 'win')) ? `/c/${community}/${sort}` : `/${sort}`;
}

const topPath = (community, top, customFeed, loggedIn) => {
    if (customFeed) return `/feed/${customFeed.id}/${customFeed.slug}/?sort=${top}`;
    const isStandardBase = isStandardBaseCommunity();
    const baseCommunity = useBaseCommunity().toLowerCase();
    if (!isStandardBase) return community.toLowerCase() === baseCommunity ? `/top?sort=${top}` : `/c/${community}/top?sort=${top}`;
    return community && (loggedIn ? community !== 'home' : (community !== 'all' && community !== 'win')) ? `/c/${community}/top?sort=${top}` : `/top?sort=${top}`;
}

const BaseMenu = styled(({className, community, onClose, heading, children}) => {
    return (
        <Overlay onClose={onClose}>
            <div className={className}>
                <Menu>
                    <Heading>{heading}</Heading>
                    {children}
                </Menu>
            </div>
        </Overlay>
    )})`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  ${Menu} {
    padding: 16px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
    border: ${({theme}) => theme.color.name === 'dark' ? `1px solid ${theme.dark_border}` : theme.standard_border};
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    width: 260px;
  }
  ${Item} {
    padding: 10px 0;
  }
  ${Item} svg {
    margin-right: 8px;
    width: 24px;
  }
  ${Heading} {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 16px;
    text-align: center;
  }
`;

export const TopSortMenu = styled(({className, community, customFeed, onClose}) => {
    const loggedIn = useLoggedIn();
    return (
        <BaseMenu className={className} community={community} onClose={onClose} heading={'Top Posts By...'}>
            <NavLink href={topPath(community, 'hour', customFeed, loggedIn)} onClick={onClose} react_route>
                <Item>
                    <Zap size={18} />
                    Hourly
                </Item>
            </NavLink>
            <NavLink href={topPath(community, 'day', customFeed, loggedIn)} onClick={onClose} react_route>
                <Item>
                    <Clock size={18} />
                    Daily
                </Item>
            </NavLink>
            <NavLink href={topPath(community, 'week', customFeed, loggedIn)} onClick={onClose} react_route>
                <Item>
                    <Calendar size={18} />
                    Weekly
                </Item>
            </NavLink>
            <NavLink href={topPath(community, 'month', customFeed, loggedIn)} onClick={onClose} react_route>
                <Item>
                    <CalendarCheck size={18} />
                    Monthly
                </Item>
            </NavLink>
            <NavLink href={topPath(community, 'all', customFeed, loggedIn)} onClick={onClose} react_route>
                <Item>
                    <Infinity size={18} />
                    All-time
                </Item>
            </NavLink>
        </BaseMenu>
    )})`
  ${Item} {
    display: flex;
    align-items: center;
  }`;

export const SortMenu = styled(({className, community, customFeed, refresh, onClose}) => {
    const loggedIn = useLoggedIn();
    return (
        <BaseMenu className={`${className} sort-feed-popup-mobile`} community={community} onClose={onClose} heading={'Sort Posts By...'}>
            <NavLink activeOnlyWhenExact href={listingPath(community, '', customFeed, loggedIn)} onClick={onClose} onRefresh={refresh} react_route>
                <Item>
                    <Rocket size={18} />
                    Hot
                </Item>
            </NavLink>
            <NavLink href={listingPath(community, 'active', customFeed, loggedIn)} onClick={onClose} onRefresh={refresh} react_route>
                <Item>
                    <MessageCircle size={18} />
                    Active
                </Item>
            </NavLink>
            <NavLink href={listingPath(community, 'new', customFeed, loggedIn)} onClick={onClose} onRefresh={refresh} react_route>
                <Item>
                    <Clock size={18} />
                    New
                </Item>
            </NavLink>
            <NavLink href={listingPath(community, 'rising', customFeed, loggedIn)} onClick={onClose} onRefresh={refresh} react_route>
                <Item>
                    <TrendingUp size={18} />
                    Rising
                </Item>
            </NavLink>
            <NavLink href={listingPath(community, 'top', customFeed, loggedIn)} onClick={onClose} onRefresh={refresh} react_route>
                <Item>
                    <ArrowUpWideNarrow size={18} />
                    Top
                </Item>
            </NavLink>
        </BaseMenu>
    )})`
    ${Item} {
      display: flex;
      align-items: center;
    }`;

export default SortMenu;
